import React from "react";
import {paymentMethodService} from "../../jwt/_services/configuration/paymentMethodService";

export const paymentMethodProvider = {
    getOptions
}

async function getOptions(customFilter) {
    try {
        const listItems = await paymentMethodService.getOptions( customFilter );

        return listItems.map( ({id, name}) => ({
                id,
                value: `${name}`,
                label: <label>{ `${name}` }</label>
            })
        );
    } catch (error) {
        console.log(error.message)
    }
}